import i18n from 'src/lib/i18n/i18n';
import View from '@play-co/timestep-core/lib/ui/View';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import { Feature } from 'src/replicant/analytics';
import sounds from 'src/lib/sounds';
import StateObserver from 'src/StateObserver';
import PopupBasicLazy from '../components/popups/PopupBasicLazy';
import { AssetGroup } from '@play-co/timestep-core';
import { ImageView } from '@play-co/timestep-core/ui';
import { lineLoginFromDemo } from './demo.utils';

/**
 * This popup should force demo user to login to LINE and continue the game
 */
export default class PopupLineDemoLogin extends PopupBasicLazy {
  /**
   * Constructor
   */
  constructor(opts: { superview: View; close: () => void }) {
    const locale = StateObserver.getLocale();

    super({
      width: 648,
      height: 972,
      zIndex: 10000,
      ...opts,
      skipTitle: true,
      boxOpts: {
        image:
          locale === 'en'
            ? 'assets/ui/demo/popup_en.png'
            : 'assets/ui/demo/popup_jp.png',
      },
      tracking: {
        feature: Feature.OPEN_WEB_DEMO._,
        $subFeature: Feature.OPEN_WEB_DEMO.POPUP_LINE_LOGIN._,
      },
    });

    // Remove close button
    this.buttonClose.removeFromSuperview();
    this.message.removeFromSuperview();

    // Login button
    const button = new ButtonScaleViewWithText({
      superview: this.box,
      image: 'assets/ui/demo/LINE_button.png',
      imagePressed: 'assets/ui/demo/LINE_button_down.png',
      imageDisabled: 'assets/ui/demo/LINE_button_down.png',
      scaleMethod: '3slice',
      sourceSlices: {
        horizontal: { left: 100, center: 20, right: 30 },
      },
      pressedOffsetY: 5,
      x: (this.box.style.width - 424) * 0.5,
      y: 819,
      width: 424,
      height: 86,
      fontSize: 50,
      font: 'Body',
      labelOffsetY: 1,
      labelPaddingX: 110,
      labelWidth: 500,
      localeText: () => i18n('openWebDemo.popupLineDemoLogin.login'),
      tracking: {
        feature: Feature.OPEN_WEB_DEMO.POPUP_LINE_LOGIN._,
        $subFeature: Feature.OPEN_WEB_DEMO.POPUP_LINE_LOGIN.LOGIN_BUTTON,
      },
      onClick: async () => {
        sounds.sfx.play('ok');
        lineLoginFromDemo();
      },
    });

    new ImageView({
      superview: button,
      image: 'assets/ui/demo/gem.png',
      x: 380,
      y: -31,
      width: 109,
      height: 106,
      scale: 0.66,
    });
  }

  /**
   * Get assets group
   */
  public getAssetsGroup() {
    const locale = StateObserver.getLocale();
    const popup =
      locale === 'en'
        ? 'assets/ui/demo/popup_en.png'
        : 'assets/ui/demo/popup_jp.png';

    return new AssetGroup([
      popup,
      'assets/ui/demo/LINE_button.png',
      'assets/ui/demo/LINE_button_down.png',
    ]);
  }

  /**
   * On popup show
   */
  public init() {
    super.init({
      title: i18n(`openWebDemo.popupLineDemoLogin.title`),
      message: i18n(`openWebDemo.popupLineDemoLogin.message`),
    });

    this.box.updateOpts({ debug: true });
  }
}
